import { useGetImagesQuery } from 'shared/store'

export const useGetIntegrations = (source?: string) => {
    let sourceName = ''
    let sourceLogo = ''

    const { data: integrations } = useGetImagesQuery()

    if (source && integrations) {
        const name = source.replace('Dev', '')
        const sourceData = integrations[name]

        sourceName = sourceData?.displayName || ''
        sourceLogo = sourceData?.image || ''
    }

    return { integrations, sourceName, sourceLogo }
}
